import "./asset/css/DarkMode.css";
import "./asset/css/index.css"
import "./asset/css/scss/index.scss"

import {Main} from "./Mian";
import React from "react";

function App() {
  return (
    <div className="App">
          <Main/>
    </div>
  );
}

export default App;
